export default function openFilter() {
  $('.filterProduct__title button').on('click', function () {
    if ($(this).find('i').hasClass('fa-plus')) {
      $(this).find('i').removeClass('fa-plus');
      $(this).find('i').addClass('fa-minus');
      $(this).parents('.filterProduct__filter').addClass('filterProduct__filter--show');
    } else {
      $(this).find('i').removeClass('fa-minus');
      $(this).find('i').addClass('fa-plus');
      $(this).parents('.filterProduct__filter').removeClass('filterProduct__filter--show');
    }
  });
}